import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import ServiceAreaBanner from "@/components/site/ServiceAreaBanner";
import About from "@/components/site/About";
import BeforeAfter from "@/components/site/BeforeAfter";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main className="bg-[#FAFAFA] text-[#111827]">
      <Header />
      <Hero />
      <Services />
      <ServiceAreaBanner />
      <About />
      <BeforeAfter />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
